import { defineStore } from 'pinia'
import type { Branding } from '~/types'

type State = {
  branding: Branding | null
  loaded: boolean
}

export const useBrandingStore = defineStore('branding', {
  state: (): State => ({
    branding: null,
    loaded: false,
  }),
  actions: {
    setBranding(branding: Branding) {
      this.branding = branding
      this.loaded = true
    },
    setLoaded(loaded: boolean) {
      this.loaded = loaded
    },
    clearBranding() {
      this.$reset()
    },
  },
  getters: {
    getCompanyFullName: (state): string => state.branding?.company_full_name ?? '',
    getHeaderLogoUrl: (state): string => state.branding?.header_logo_url ?? '',
    getEmailLogoUrl: (state): string | null => state.branding?.email_logo_url ?? null,
    getFaviconUrl: (state): string => state.branding?.favicon_url ?? '',
  },
})
